const getters = {
    sidebar: (state) => state.app.sidebar,
    isMobile: (state) => state.app.isMobile,
    isMobileNavShow: (state) => state.app.isMobileNavShow,
    permissionRoutes: (state) => state.permission.routes,
    hasPermission: (state) => state.permission.hasPermission,
    checkedDevices: (state) => state.device.checkedDevices,
    counts: (state) => state.app.counts,
};
export default getters;
